import curry from "../../../lib/core/functional/curry";

export default curry(function renderView(element, props) {
    const { editor, saveSiteAbout } = props;

    const saveButton = document.createElement("button");
    saveButton.type = "button";
    saveButton.classList.add("rm-button", "rm-save-button");
    saveButton.textContent = "Update about";
    function onClick() {
        editor.disable();
        saveButton.classList.add("rm-button-loading");
        saveButton.textContent = "Saving...";
        saveSiteAbout(editor.getContent());
    }
    saveButton.addEventListener("click", onClick, { passive: true });

    element.textContent = "";
    element.appendChild(editor.parent);
    element.appendChild(saveButton);

    return function cleanup() {
        saveButton.remove();
        editor.destroy();
    };
});
